import styled from "@emotion/styled";
import { Grid } from "@mui/material";

export const ContestsContainer = styled(Grid)`
  margin: 0;
  width: 100%;
  padding: 10px;
  background: #f5f5f5;
`;

/* Main Contest Card */
export const ContestContainerJ = styled(Grid)`
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
  margin-bottom: 14px;
  padding: 14px;
  cursor: pointer;
  position: relative;
  transition: 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }
`;

/* Wrapper */
export const ContestJ = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

/* Top Section */
export const First = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  h5 {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #000;
  }

  p {
    margin: 0;
    font-size: 13px;
    color: #666;
  }
`;

/* Divider Line */
export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #eee;
  margin: 6px 0;
`;

/* Bottom Info Section */
export const LastJ = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: #555;
`;

/* Small Tag Red */
export const F = styled.span`
  background: #fdecea;
  color: #d32f2f;
  font-weight: 600;
  border-radius: 6px;
  padding: 2px 8px;
  font-size: 12px;
`;

/* Small Tag Green */
export const M = styled.span`
  background: #e8f5e9;
  color: #2e7d32;
  font-weight: 600;
  border-radius: 6px;
  padding: 2px 8px;
  font-size: 12px;
`;

/* Small Neutral Tag */
export const C = styled.span`
  background: #f2f2f2;
  color: #444;
  font-weight: 600;
  border-radius: 6px;
  padding: 2px 8px;
  font-size: 12px;
`;

/* Status Section */
export const StatusC = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  margin-top: 6px;
`;

/* Spots Left */
export const SpotsLeft = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #d32f2f;
`;

/* Total Spots */
export const SpotsRight = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #444;
`;

/* No Contest Section */
export const NoContests = styled.div`
  width: 100%;
  text-align: center;
  padding: 40px 0;
  color: #666;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);

  img {
    width: 100px;
    margin: 15px 0;
  }
`;

/* Join Button */
export const JoincontestBtn = styled.button`
  background: #d32f2f;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 700;
  margin-top: 15px;
  cursor: pointer;
  transition: 0.2s ease;

  &:hover {
    background: #b71c1c;
  }
`;
